import type {StatefulPromise} from 'src/internal/revamp/fetchUtils/statefulPromise';
import type {FetchState} from 'src/internal/shared/fetch/types';

type StatefulPromiseMap = Map<string, StatefulPromise<FetchState<any>>>;
type Observer = () => void;

export default class RawFetchCache {
  private fetchMap: StatefulPromiseMap;
  private observers: Map<string, Set<Observer>>;
  constructor() {
    this.fetchMap = new Map();
    this.observers = new Map();
  }

  addStatefulPromise<T>(
    key: string,
    statefulPromise: StatefulPromise<FetchState<T>>,
  ) {
    this.fetchMap.set(key, statefulPromise);
    this.notifyObservers(key);
  }

  getStatefulPromise<T>(
    key: string,
  ): StatefulPromise<FetchState<T>> | undefined {
    return this.fetchMap.get(key);
  }

  subscribe(key: string, observer: Observer) {
    if (!this.observers.has(key)) {
      this.observers.set(key, new Set());
    }

    this.observers.get(key)!.add(observer);

    return () => {
      const observers = this.observers.get(key);

      if (observers) {
        observers.delete(observer);

        if (observers.size === 0) {
          this.observers.delete(key);
          this.fetchMap.delete(key);
        }
      }
    };
  }

  private notifyObservers(key: string) {
    const observers = this.observers.get(key);

    if (observers) {
      observers.forEach((observer) => observer());
    }
  }
}
